import { render, staticRenderFns } from "./editMain.vue?vue&type=template&id=59788b4e&scoped=true&"
import script from "./editMain.vue?vue&type=script&lang=js&"
export * from "./editMain.vue?vue&type=script&lang=js&"
import style0 from "./editMain.vue?vue&type=style&index=0&id=59788b4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59788b4e",
  null
  
)

export default component.exports